/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.TagManager.Host.Api
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type MapCreditsOptionsMapMigrationType = typeof MapCreditsOptionsMapMigrationType[keyof typeof MapCreditsOptionsMapMigrationType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MapCreditsOptionsMapMigrationType = {
  ComputeStorageAndOther: 'ComputeStorageAndOther',
  DatabaseAndAnalytics: 'DatabaseAndAnalytics',
  SAP: 'SAP',
  Oracle: 'Oracle',
} as const;
